import { createStore } from 'vuex';
import config from './config';

export const store = createStore(config);
